export const ShopifyTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {
      integration: `shopify`
    };
  }
};